module.exports = __webpack_public_path__ + "3cae1d37a41a4dd2cba438a243879292.svg";